import { Alert, AlertDescription, AlertTitle } from "@chakra-ui/react";
import { AlertIcon } from "view-layer/components/common/icons/AlertIcon";

export const CardDeclined = () => (
  <Alert status="error" variant="error" data-testid="payment-declined-message">
    <AlertIcon status="error" />
    <AlertTitle>Payment not accepted</AlertTitle>
    <AlertDescription>Please try to make the payment with a different card or use another payment method if available.</AlertDescription>
  </Alert>
);